import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE || '';
const TOKEN_KEY = 'customer_token';

const getToken = () => { try { return localStorage.getItem(TOKEN_KEY); } catch { return null; } };

const CustomerContext = createContext(null);

// 客人登入狀態（Google 登入）。全站共用：
// - 進站/登入導回時（任何頁面，含 /cart）自動抓網址的 ctoken 存起來並清網址 → 修正「登入回來卻沒真的登入」。
// - 提供 customer / isLoggedIn 給 header 呈現登入狀態，以及 login()/logout()。
export function CustomerProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback((tk) => {
    const token = tk || getToken();
    if (!token) { setCustomer(null); setLoading(false); return; }
    setLoading(true);
    fetch(`${API_BASE}/api/auth/google/customer/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((info) => {
        if (info) setCustomer(info);
        else { try { localStorage.removeItem(TOKEN_KEY); } catch {} setCustomer(null); }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    let token = getToken();
    try {
      const q = new URLSearchParams(window.location.search);
      const ctoken = q.get('ctoken');
      if (ctoken) {
        localStorage.setItem(TOKEN_KEY, ctoken);
        token = ctoken;
        q.delete('ctoken');
        const rest = q.toString();
        window.history.replaceState(null, '', window.location.pathname + (rest ? `?${rest}` : ''));
      }
    } catch { /* ignore */ }
    fetchMe(token);
  }, [fetchMe]);

  const login = useCallback((next = '/member') => {
    window.location.href = `${API_BASE}/api/auth/google/customer/login?next=${encodeURIComponent(next)}`;
  }, []);

  const logout = useCallback(() => {
    try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
    setCustomer(null);
  }, []);

  const value = {
    customer,
    isLoggedIn: !!customer,
    loading,
    login,
    logout,
    refresh: () => fetchMe(),
  };
  return <CustomerContext.Provider value={value}>{children}</CustomerContext.Provider>;
}

export function useCustomer() {
  return useContext(CustomerContext) || {
    customer: null, isLoggedIn: false, loading: false,
    login: () => {}, logout: () => {}, refresh: () => {},
  };
}
